import api from './api';

export const getMissions = () => api.get('/api/missions');
export const getDailyMissions = () => api.get('/api/missions/daily');
export const claimMission = (id) => api.post(`/api/missions/${id}/claim`);
